import type { IModuleInfo, IRecordTypeDefinition } from '@platform/core/types';

/**
 * Позначка конструктора (прототип v4 bKind = core ? «Основна сутність» : «Власний модуль»): головна таблиця основного модуля — основна
 * сутність; решта (дочірні таблиці — у прототипі окремі неосновні модулі, модулі каталогу й власні модулі) — «Власний модуль». Чиста функція.
 */
export function isCoreEntity(module: Pick<IModuleInfo, 'core'>, rt: Pick<IRecordTypeDefinition, 'main'>): boolean {
  return module.core && rt.main;
}
